import styled from '@emotion/styled';

export const ReportListingWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    color: ${theme.colors.neutrals.grey3};
    cursor: pointer;

    > svg {
      height: 16px;
      width: 16px;
      margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(1)};
      path {
        fill: ${theme.colors.neutrals.grey3};
      }
    }
  `}
`;
